module.exports = __webpack_public_path__ + "img/penny-arcade.8d7f2162.svg";